import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../CartContext';

export default function Navbar() {
  const { cartCount } = useCart();
  const navigate = useNavigate();

  return (
    <nav style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '16px 32px', background: '#111', color: '#fff',
      fontFamily: 'sans-serif', position: 'sticky', top: 0, zIndex: 100,
    }}>
      <span onClick={() => navigate('/')}
        style={{ fontSize: '20px', fontWeight: 'bold', cursor: 'pointer' }}>
        Auth.Today
      </span>
      <button onClick={() => navigate('/checkout')}
        style={{
          background: 'transparent', border: '2px solid #fff', color: '#fff',
          padding: '8px 20px', borderRadius: '6px', cursor: 'pointer', fontSize: '15px',
        }}>
        🛒 Basket {cartCount > 0 && <span style={{
          background: '#e53', borderRadius: '50%', padding: '2px 7px',
          fontSize: '12px', marginLeft: '6px',
        }}>{cartCount}</span>}
      </button>
    </nav>
  );
}
